export default __webpack_public_path__ + "7bf83ff5d761eb105b4ad4d853b8de2c.png";